import ReactDom from 'react-dom'
import { Provider } from 'react-redux'
import { store } from './store/store'
import 'react-tooltip/dist/react-tooltip.css'
import './css/bootstrap-isolate.scss'
// import './css/theme-override.scss'
import AppRouter from './components/AppRouter/AppRouter'
import { ApiSettingsType } from './model/model'

declare global {
  interface Window {
    ChongerApiSettings: ApiSettingsType
  }
}

const timer = setInterval(() => {
  if (typeof window.ChongerApiSettings === 'object') {
    ReactDom.render(
      <Provider store={store}>
        <AppRouter config={window.ChongerApiSettings} />
      </Provider>,
      document.getElementById('chonger-root')
    )

    clearInterval(timer)
  }
}, 100)
